module.exports = __webpack_public_path__ + "static/lframe-calculator-budget-planner-82176696a9f27fa7fa02dd43ceea629a.png";